import folderIcon from "../../assets/folder.svg"
import { MySelector } from "../../redux/store"

const NoFiles = () => {
  const { type } = MySelector((state) => state.util)
  const { theme } = MySelector((state) => state.theme)

  return (
    <div className="flex flex-col items-center justify-center gap-2 h-full mt-24">
      <img
        src={theme === "dark" ? folderIcon : folderIcon}
        alt=""
        className="h-12 w-12 lg:h-16 lg:w-16"
      />
      <p className="text-sm lg:text-lg text-blackish dark:text-grey mb-36">
        No files in {type === "gallery" ? "gallery" : "physical album"}
      </p>
    </div>
  )
}

export default NoFiles
